import React from 'react';
const situations = [{
  emoji: '😔',
  text: 'Tus clientes dicen “qué bonito huele”… pero al escuchar el precio deciden no comprar.'
}, {
  emoji: '😓',
  text: 'Sabes que tu producto es mejor que muchos otros… pero no encuentras las palabras para justificar su valor.'
}, {
  emoji: '📱',
  text: 'Publicas en Instagram o WhatsApp… y solo reaccionan con un “qué lindo”, pero casi nadie compra.'
}, {
  emoji: '🤷‍♀️',
  text: 'Todos tus productos parecen independientes… y no sabes cómo convertirlos en una colección.'
}, {
  emoji: '💸',
  text: 'Trabajas muchísimo… pero tus ingresos dependen de promociones y descuentos.'
}, {
  emoji: '😞',
  text: 'Ves otras marcas cobrando mucho más… aunque tu calidad sea igual o mejor.'
}];
export function Identify() {
  return <section className="w-full bg-[#efe7da] px-5 py-14" data-id="element-145" data-mp="3uoacgfqxgvag">
      <div className="mx-auto max-w-md" data-id="element-146" data-mp="3pp5ylbt269ds">
        <h2 className="text-center font-serif-display text-3xl font-bold leading-tight text-[#3b3350]" data-id="element-147" data-mp="3pqh4pi9z7t82">
          ¿Te identificas con alguna de estas situaciones?
        </h2>
        <p className="mt-3 text-center text-sm text-[#7a7288]" data-id="element-148" data-mp="1wr5a2co8fd3h">
          Esta Biblioteca fue creada para ti si…
        </p>

        <div className="mt-8 space-y-3" data-id="element-149" data-mp="1is5gcqlv480g">
          {situations.map(s => <div key={s.text} className="flex gap-3 rounded-2xl bg-white p-4 shadow-sm ring-1 ring-[#e4dbcc]" data-id="element-150" data-mp="1nq72jkel4ng5">
              <span className="text-2xl leading-none" data-id="element-151" data-mp="2fgk3pm1l8zxu">{s.emoji}</span>
              <p className="text-sm leading-relaxed text-[#5a5266]" data-id="element-152" data-mp="2fio8s7b844zp">{s.text}</p>
            </div>)}
        </div>

        <div className="mt-8 rounded-2xl bg-[#3b3350] p-6 text-center text-white" data-id="element-153" data-mp="26o9ua6yioyhn">
          <p className="text-base leading-relaxed" data-id="element-154" data-mp="26m5kj8dxt59g">
            Si respondiste “sí” a una o varias…
          </p>
          <p className="mt-3 font-serif-display text-2xl font-semibold leading-snug text-[#c9b8ea]" data-id="element-155" data-mp="2z4km4d2b2gqd">
            No necesitas producir más. Necesitas que tus clientes perciban más valor.
          </p>
        </div>
      </div>
    </section>;
}